Wee.routes.addFilter({
	'isPaginated': function(seg) {
		return /^p\d+$/.test(seg);
	},
	'notPaginated': function(seg) {
		return seg && ! /^p\d+$/.test(seg);
	}
});

Wee.routes.map({
	'$any:once': [
		'common',
		'header',
		'navigation',
		'search'
	],
	'$any:pop': [
		'search:pop',
		'infieldLabels:destroy'
	],
	'$any': [
		'navigation:links',
		'infieldLabels'
	],
	'$root': 'home',
	'$root:unload': 'home:unload',
	'about': 'about',
	'about:unload': 'about:unload',
	'store': {
		'$notPaginated': 'product',
		'$notPaginated:unload': 'product:unload'
	},
	'cart': 'cart',
	'cart:unload': 'cart:unload',
	'checkout': {
		'shipping-and-billing': 'addresses',
		'shipping-and-billing:unload': 'addresses:unload'
	},
	'blog': {
		'$root||$isPaginated': 'categories',
		'$root:unload': 'categories:unload',
		'$isPaginated:unload': 'categories:unload'
	},
	'category': {
		'$slug': {
			'$root||$isPaginated': 'categories',
			'$root:unload': 'categories:unload',
			'$isPaginated:unload': 'categories:unload'
		}
	},
	'contact': 'contact',
	'contact:unload': 'contact:unload',
	'search-results': 'search:clearInput'
});

Wee.ready('routes:run');